"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const core_1 = require("@emotion/core");
const merlin_modal_1 = require("@travelnest/merlin.modal");
const GlobalFonts_1 = require("./GlobalFonts");
const GlobalStyles = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(GlobalFonts_1.GlobalFonts, null),
        React.createElement(core_1.Global, { styles: (0, core_1.css) `
				h1, h2, h3, h4, h5, p {
					max-width 55ch;
					margin: 0;
				}
				body {
					margin: 0;
				}

				*,
				*::before,
				*::after {
					box-sizing: border-box;
				}

				${merlin_modal_1.BodyOverlayCSS}

				// Lives here as the Modal inserts itself in the root of the body.
				// TODO: Port into Merlin


				.travelnest-modal__content {
					max-width: 100% !important;
				}

				.ReactModal__Content {

					// Needed to stop modal looking massive on large desktops
					max-height: 700px;

					// Overrides 80px on bottom meaning modal for pricing takes up whole of iFrame
					// with 10px border all way round
					inset: 10px !important;
				}
			` }));
};
exports.default = GlobalStyles;
//# sourceMappingURL=index.js.map